var memberStatuses = [
    {"name": "ثبت نام شده", id: 0},
    {"name": "در انتظار پرداخت", id: 1},
    {"name": "غایب", id: 2},
    {"name": "حاضر در کلاس", id: 3},
    {"name": "گواهی صادر شد", id: 4},
];

export default memberStatuses;